import { styled } from '@clickcease/cc-client-components-lib'

export const InstallationKeyRowStyled = styled('div', {
  display: 'flex',
  marginBottom: '12px',
  color: '$mainTextColor',
  width: '100%x',
})

export const InstallationKeyRowText = styled('div', {
  fontSize: '$md',
  fontWeight: '$l',
  lineHeight: '25px',
  width: '200px',
})

export const InstallationKeyRowKey = styled('div', {
  display: 'flex',
  alignItems: 'center',
  padding: '0 $6',
  background: '$offWhite',
  border: '1px dashed $neutral',
  borderRadius: '12px',
})
